<template>
  <div class="loader" v-if="isLoading"></div>
  <div v-else class="content content--center">
    <h1>Выберите уровень образования</h1>

    <div class="robot">
      <ul class="robot__content" :class="{ 'robot__content--multiline': campaigns?.length > 3 }">
        <a
          class="card card--lg card--active robot__content-item"
          v-for="campaign in campaigns"
          :key="campaign.id"
          @click="onSelectCampaign(campaign.education_level)"
        >
          <div class="card__header">
            <p class="card__title">{{ campaign.name }}</p>
            <img class="card__icon icon" src="~images/arrow.svg" v-svg-inline/>
          </div>
        </a>
      </ul>
      <img class="robot__img" src="~images/robot-entrance.svg" v-svg-inline>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'campaigns',
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapState('campaigns', ['campaigns'])
  },
  async created() {
    this.isLoading = true
    await this.getCampaigns()
    this.isLoading = false
  },
  methods: {
    ...mapActions('campaigns', ['getCampaigns']),
    onSelectCampaign(education_level) {
      this.$router.push({
        name: 'education_level_index',
        params: {
          education_level,
          edu_form: 'fulltime'
        },
      })
    }
  }
}
</script>